import { Dispatch } from 'react-redux';
import { AxiosError } from "axios";
import { AuthActionCreators, IApplicationState } from "../";
import { IListItem, IBaseResponse, IReferral, INkrReferralDonatedNkr } from "../../models";
import { IPost } from '../authorization';
import { IGet, IPut } from '../authorization/actions';

export interface ILookupData {
    dispositions: IListItem[]
}

export const ActionTypes = {
    SET_REFERRAL_LOOKUP_DATA: "SET_REFERRAL_LOOKUP_DATA",
}

export interface IReferralListResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            list: IReferral[],
            isKidneyForLifeParticipant: boolean,
            isMicrositeParticipant: boolean
        }
    }
}

export interface IReferralResponse {
    data: {
        success: boolean,
        message: string,
        results: IReferral
    }
}

export interface IReferralLookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: ILookupData
    }
}

export interface INkrReferralDonatedNkrResponse {
    data: {
        success: boolean,
        message: string,
        results: INkrReferralDonatedNkr[]
    }
}

export const ActionCreators = {
    getReferralLookupData: () => (dispatch: Dispatch<IApplicationState>): Promise<IReferralLookupDataResponse> => {
        var options = {
            url: __API__ + `/referral/lookup-data`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IReferralLookupDataResponse) => {
                if (response.data.success) {
                    dispatch(ActionCreators.setReferralLookupData(response.data.results));
                }

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    setReferralLookupData: (lookupData: ILookupData) => {
        return {
            type: ActionTypes.SET_REFERRAL_LOOKUP_DATA,
            lookupData
        };
    },
    getCenterReferralList: (centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IReferralListResponse> => {
        var options = {
            url: `${__API__}/referral/by-center/${centerId}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IReferralListResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getReferral: (id: number) => (dispatch: Dispatch<IApplicationState>): Promise<IReferralResponse> => {
        var options = {
            url: `${__API__}/referral/${id}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IReferralResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    updateReferralDisposition: (data: { id: number, disposition: string }[]) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPut = {
            url: `${__API__}/referral/disposition`,
            data
        };

        return dispatch(AuthActionCreators.apiPut(options))
            .then((response: IBaseResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    markRetrieved: (id: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPost = {
            url: `${__API__}/referral/retrieved/${id}`,
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: IBaseResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    createMicrositeFromReferral: (id: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPost = {
            url: `${__API__}/referral/create-microsite/${id}`,
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: IBaseResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getNkrReferralDonatedNkr: () => async (dispatch: Dispatch<IApplicationState>): Promise<INkrReferralDonatedNkrResponse> => {
        let options: IGet = {
            url: `${__API__}/referral/report/nkr-referral-donated-nkr`,
        }

        try {
            const response = await dispatch(AuthActionCreators.apiGet(options));
            // return await Promise.resolve(response);
            return response;
        } catch (error) {
            throw error;
        }
    }
}

export interface IReferralState {
    lookupData: ILookupData,
}

var initialState: IReferralState = {
    lookupData: {
        dispositions: []
    }
};

interface ISetReferralLookupData {
    type: string,
    lookupData: ILookupData
}

const setReferralLookupData = (state: IReferralState, action: ISetReferralLookupData) => {
    state.lookupData = action.lookupData;
    return state;
}

const createReducer = (initialState: IReferralState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
    [ActionTypes.SET_REFERRAL_LOOKUP_DATA]: setReferralLookupData
};

export const Reducer = createReducer(initialState, handlers);
